var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledStoreFront({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 113,
    viewBox: "0 0 182 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.2805,
    y: 25.2917,
    width: 117.333,
    height: 78.0895,
    fill: "#8895A6",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8132,
    y: 39.0027,
    width: 78.697,
    height: 52.2284,
    fill: "#EFF2F4",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9065,
    y: 103.05,
    width: 126.728,
    height: 4.84519,
    fill: "#262F3D",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9844,
    y: 21.9929,
    width: 120.572,
    height: 3.54346,
    fill: "#262F3D",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_2175_4486",
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: -0.0585938,
    width: 125,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27,
    y: -0.0585938,
    width: 125,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9386 0.941406C32.0019 0.941406 28 4.94335 28 9.87999C28 14.8166 32.0019 18.8186 36.9386 18.8186H142.061C146.998 18.8186 151 14.8166 151 9.87999C151 4.94335 146.998 0.941406 142.061 0.941406H36.9386ZM37 3.00098C33.134 3.00098 30 6.13498 30 10.001C30 13.867 33.134 17.001 37 17.001H142C145.866 17.001 149 13.867 149 10.001C149 6.13498 145.866 3.00098 142 3.00098H37Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9386 0.941406C32.0019 0.941406 28 4.94335 28 9.87999C28 14.8166 32.0019 18.8186 36.9386 18.8186H142.061C146.998 18.8186 151 14.8166 151 9.87999C151 4.94335 146.998 0.941406 142.061 0.941406H36.9386ZM37 3.00098C33.134 3.00098 30 6.13498 30 10.001C30 13.867 33.134 17.001 37 17.001H142C145.866 17.001 149 13.867 149 10.001C149 6.13498 145.866 3.00098 142 3.00098H37Z",
    fill: "#EDC455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.94 9.87999C28.94 5.46249 32.5211 1.88139 36.9386 1.88139V0.00142187C31.4828 0.00142187 27.06 4.42421 27.06 9.87999H28.94ZM36.9386 17.8786C32.5211 17.8786 28.94 14.2975 28.94 9.87999H27.06C27.06 15.3358 31.4828 19.7586 36.9386 19.7586V17.8786ZM142.061 17.8786H36.9386V19.7586H142.061V17.8786ZM150.06 9.87999C150.06 14.2975 146.479 17.8786 142.061 17.8786V19.7586C147.517 19.7586 151.94 15.3358 151.94 9.87999H150.06ZM142.061 1.88139C146.479 1.88139 150.06 5.46249 150.06 9.87999H151.94C151.94 4.42421 147.517 0.00142187 142.061 0.00142187V1.88139ZM36.9386 1.88139H142.061V0.00142187H36.9386V1.88139ZM30.94 10.001C30.94 6.65412 33.6531 3.94096 37 3.94096V2.06099C32.6149 2.06099 29.06 5.61584 29.06 10.001H30.94ZM37 16.061C33.6531 16.061 30.94 13.3478 30.94 10.001H29.06C29.06 14.3861 32.6149 17.941 37 17.941V16.061ZM142 16.061H37V17.941H142V16.061ZM148.06 10.001C148.06 13.3478 145.347 16.061 142 16.061V17.941C146.385 17.941 149.94 14.3861 149.94 10.001H148.06ZM142 3.94096C145.347 3.94096 148.06 6.65412 148.06 10.001H149.94C149.94 5.61584 146.385 2.06099 142 2.06099V3.94096ZM37 3.94096H142V2.06099H37V3.94096Z",
    fill: "black",
    mask: "url(#path-5-outside-1_2175_4486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7152 5.72727V13H78.3871L75.223 8.42259H75.1697V13H73.6321V5.72727H74.9815L78.1207 10.3011H78.1847V5.72727H79.7152ZM82.1292 13H80.4814L82.9921 5.72727H84.9736L87.4807 13H85.833L84.0113 7.3892H83.9545L82.1292 13ZM82.0262 10.1413H85.9182V11.3416H82.0262V10.1413ZM88.2461 5.72727H90.1424L92.1452 10.6136H92.2305L94.2333 5.72727H96.1296V13H94.6381V8.26634H94.5778L92.6957 12.9645H91.68L89.7979 8.24858H89.7376V13H88.2461V5.72727ZM97.2865 13V5.72727H102.187V6.99503H98.8241V8.72798H101.935V9.99574H98.8241V11.7322H102.201V13H97.2865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4861,
    y: 40.9128,
    width: 73.8372,
    height: 47.6289,
    fill: "#59A985",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2866 87.8105L78.8505 43.6816H90.19L58.5203 87.8105H49.2866Z",
    fill: "#8895A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.573 43.6816H96.0218L63.5421 87.8105H84.3988L111.573 43.6816Z",
    fill: "#8895A6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.296,
    y: 39.0027,
    width: 21.7562,
    height: 61.2537,
    fill: "#FBFFFD",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.835,
    y: 41.8659,
    width: 18.6783,
    height: 35.4794,
    fill: "#59A985",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.835,
    y: 80.7449,
    width: 18.6783,
    height: 16.8212,
    fill: "#59A985",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.57,
    y: 99.9245,
    width: 29.2079,
    height: 3.45667,
    fill: "#FBFFFD",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4763 96.6202H35.868H38.0816V98.961H32.1421V96.6202H35.4763ZM35.0847 95.8369H32.1421V93.496H35.0847V95.8369ZM65.0674 96.9239H66.4305V99.2648H60.4911V96.9239H64.6757H65.0674ZM60.0994 96.1406H59.7077H58.3446V93.7998H64.2841V96.1406H60.0994ZM32.1421 59.3038H35.0847V61.6446H32.1421V59.3038ZM32.1421 70.6289H35.0847V72.9697H32.1421V70.6289ZM32.1421 80.739H35.0847V83.0799H32.1421V80.739ZM96.3727 93.7998H102.312V96.1406H96.3727V93.7998ZM144.768 77.3979H147.994V79.7387H144.768V77.3979ZM144.768 59.4339H147.994V61.7748H144.768V59.4339Z",
    fill: "#B9CCC9",
    stroke: "black",
    strokeWidth: 0.78332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.343 87.2463C179.343 92.4577 175.407 96.6261 170.62 96.6261C165.832 96.6261 161.897 92.4577 161.897 87.2463C161.897 82.0349 165.832 77.8665 170.62 77.8665C175.407 77.8665 179.343 82.0349 179.343 87.2463Z",
    fill: "#83D8F9",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1844 87.2463C20.1844 92.4577 16.2489 96.6261 11.4612 96.6261C6.67356 96.6261 2.73806 92.4577 2.73806 87.2463C2.73806 82.0349 6.67356 77.8665 11.4612 77.8665C16.2489 77.8665 20.1844 82.0349 20.1844 87.2463Z",
    fill: "#83D8F9",
    stroke: "black",
    strokeWidth: 0.939984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4202 106.903V93.7559M11.4202 84.123V93.7559M11.6227 88.4188L13.4857 86.4228M11.7442 93.5823L15.2271 89.5036M11.4202 93.7559L7.41089 89.8507M170.66 86.4228V93.322M170.66 107.034V93.322M170.66 93.322L174.75 89.6337M170.296 93.6257L166.894 89.6337",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.788 76.8773L138.586 46.5469H140.691L128.08 76.8773H125.788Z",
    fill: "#8895A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.352 97.096L139.09 81.2148H140.692L131.096 97.096H129.352Z",
    fill: "#8895A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.623 76.8766L139.963 51.8398V55.6149L130.915 76.8766H128.623Z",
    fill: "#8895A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.458 97.0963L140.124 83.9922V85.968L133.209 97.0963H131.458Z",
    fill: "#8895A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4046 30.2734H50.5822L40.66 39.4724V46.9357C40.66 46.9357 40.336 52.7935 33.7753 52.7935C27.2146 52.7935 26.8096 46.9357 26.8096 46.9357V39.9063V39.4724L39.4046 30.2734Z",
    fill: "#FE2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8096 39.4724L39.4046 30.2734H50.5822L40.66 39.4724M26.8096 39.4724H40.66M26.8096 39.4724V39.9063V46.9357C26.8096 46.9357 27.2146 52.7935 33.7753 52.7935C40.336 52.7935 40.66 46.9357 40.66 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61 30.2734H129.433L139.355 39.4724V46.9357C139.355 46.9357 139.679 52.7935 146.24 52.7935C152.8 52.7935 153.205 46.9357 153.205 46.9357V39.9063V39.4724L140.61 30.2734Z",
    fill: "#FE2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.205 39.4724L140.61 30.2734H129.433L139.355 39.4724M153.205 39.4724H139.355M153.205 39.4724V39.9063V46.9357C153.205 46.9357 152.8 52.7935 146.24 52.7935C139.679 52.7935 139.355 46.9357 139.355 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7599 30.2734H72.9375L69.0092 39.4724V46.9357C69.0092 46.9357 68.6852 52.7935 62.1244 52.7935C55.5637 52.7935 55.1587 46.9357 55.1587 46.9357V39.9063V39.4724L61.7599 30.2734Z",
    fill: "#FE2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1587 39.4724L61.7599 30.2734H72.9375L69.0092 39.4724M55.1587 39.4724H69.0092M55.1587 39.4724V39.9063V46.9357C55.1587 46.9357 55.5637 52.7935 62.1244 52.7935C68.6852 52.7935 69.0092 46.9357 69.0092 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.255 30.2734H107.078L111.006 39.4724V46.9357C111.006 46.9357 111.33 52.7935 117.891 52.7935C124.452 52.7935 124.857 46.9357 124.857 46.9357V39.9063V39.4724L118.255 30.2734Z",
    fill: "#FE2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.857 39.4724L118.255 30.2734H107.078L111.006 39.4724M124.857 39.4724H111.006M124.857 39.4724V39.9063V46.9357C124.857 46.9357 124.452 52.7935 117.891 52.7935C111.33 52.7935 111.006 46.9357 111.006 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1558 30.2734H95.7384L97.0343 39.4724V46.9357C97.0343 46.9357 96.7103 52.7935 90.1496 52.7935C83.5888 52.7935 83.1838 46.9357 83.1838 46.9357V39.9063V39.4724L84.1558 30.2734Z",
    fill: "#FE2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1838 39.4724L84.1558 30.2734H95.7384L97.0343 39.4724M83.1838 39.4724H97.0343M83.1838 39.4724V39.9063V46.9357C83.1838 46.9357 83.5888 52.7935 90.1496 52.7935C96.7103 52.7935 97.0343 46.9357 97.0343 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5418 30.2734H61.7193L54.8346 39.4724V46.9357C54.8346 46.9357 54.5106 52.7935 47.9499 52.7935C41.3891 52.7935 40.9841 46.9357 40.9841 46.9357V39.9063V39.4724L50.5418 30.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9841 39.4724L50.5418 30.2734H61.7193L54.8346 39.4724M40.9841 39.4724H54.8346M40.9841 39.4724V39.9063V46.9357C40.9841 46.9357 41.3891 52.7935 47.9499 52.7935C54.5106 52.7935 54.8346 46.9357 54.8346 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.473 30.2734H118.296L125.181 39.4724V46.9357C125.181 46.9357 125.505 52.7935 132.065 52.7935C138.626 52.7935 139.031 46.9357 139.031 46.9357V39.9063V39.4724L129.473 30.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.031 39.4724L129.473 30.2734H118.296L125.181 39.4724M139.031 39.4724H125.181M139.031 39.4724V39.9063V46.9357C139.031 46.9357 138.626 52.7935 132.065 52.7935C125.505 52.7935 125.181 46.9357 125.181 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8562 30.2734H84.0338L82.9403 39.4724V46.9357C82.9403 46.9357 82.6163 52.7935 76.0556 52.7935C69.4948 52.7935 69.0898 46.9357 69.0898 46.9357V39.9063V39.4724L72.8562 30.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0898 39.4724L72.8562 30.2734H84.0338L82.9403 39.4724M69.0898 39.4724H82.9403M69.0898 39.4724V39.9063V46.9357C69.0898 46.9357 69.4948 52.7935 76.0556 52.7935C82.6163 52.7935 82.9403 46.9357 82.9403 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.159 30.2734H95.9811L97.0746 39.4724V46.9357C97.0746 46.9357 97.3986 52.7935 103.959 52.7935C110.52 52.7935 110.925 46.9357 110.925 46.9357V39.9063V39.4724L107.159 30.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.925 39.4724L107.159 30.2734H95.9811L97.0746 39.4724M110.925 39.4724H97.0746M110.925 39.4724V39.9063V46.9357C110.925 46.9357 110.52 52.7935 103.959 52.7935C97.3986 52.7935 97.0746 46.9357 97.0746 46.9357V39.4724",
    stroke: "black",
    strokeWidth: 1.09665
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledStoreFront);
export default __webpack_public_path__ + "static/media/disabledStoreFront.08ce111696de350bfb3dad85240cc5c7.svg";
export { ForwardRef as ReactComponent };